module.exports = __webpack_public_path__ + "img/link.57ffc065.svg";